var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeftDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290039 6.23313C-0.0966797 6.61985 -0.0966797 7.24788 0.290039 7.6346L6.23004 13.5746C6.61676 13.9613 7.24479 13.9613 7.63151 13.5746C8.01823 13.1879 8.01823 12.5599 7.63151 12.1731L2.3907 6.93232L7.62841 1.69151C8.01513 1.30479 8.01513 0.676758 7.62841 0.290039C7.2417 -0.0966797 6.61366 -0.0966797 6.22695 0.290039L0.286945 6.23004L0.290039 6.23313Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29004 6.23313C6.90332 6.61985 6.90332 7.24788 7.29004 7.6346L13.23 13.5746C13.6168 13.9613 14.2448 13.9613 14.6315 13.5746C15.0182 13.1879 15.0182 12.5599 14.6315 12.1731L9.3907 6.93232L14.6284 1.69151C15.0151 1.30479 15.0151 0.676758 14.6284 0.290039C14.2417 -0.0966797 13.6137 -0.0966797 13.2269 0.290039L7.28695 6.23004L7.29004 6.23313Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftDouble);
export default __webpack_public_path__ + "static/media/icon-arrow-left-double.02a77b68258d5181d2bfd93f9826aeb9.svg";
export { ForwardRef as ReactComponent };